module.exports = __webpack_public_path__ + "static/media/appointment-planning-icon-diagnosis.f3c987fe.svg";